// Управление сессией пользователя (JWT / sessionKey / userId).
// Источник истины — localStorage.currentSession
import { rootStore } from "@/store/index"
import { authStore } from "@/store/login"

const SESSION_KEY = "currentSession"

export type StoredSession = {
  id: number
  sessionKey: string
  jwtToken: string
}

/** Читаем сохранённую сессию из localStorage. */
export function loadSession(): StoredSession | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed && parsed.jwtToken) {
      return {
        id: parsed.id,
        sessionKey: parsed.sessionKey,
        jwtToken: parsed.jwtToken,
      }
    }
    return null
  } catch (e) {
    return null
  }
}

/** Наполняем стору данными сессии */
export function applySession(session: StoredSession): void {
  const auth = authStore()
  auth.setUserId(session.id)
  auth.setSessionKey(session.sessionKey)
  auth.setJWT(session.jwtToken)
  rootStore().setToken(session.jwtToken)
}

/** Полностью очищаем сессию: localStorage и стору. */
export function clearSession(): void {
  localStorage.removeItem(SESSION_KEY)
  const auth = authStore()
  auth.currentUserId = null
  auth.sessionKey = null
  auth.jwtToken = null
  auth.currentWorker = null
  rootStore().setToken("")
}
